import React, { useState, useEffect } from 'react';
import { Row, Col, Form } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

import DatePicker from 'react-datepicker';
import { toast } from 'react-toastify';
import axios from 'axios';
import moment from 'moment';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from '../../config/firebase';
import KeywordsMaker from '../utilities/KeywordsMaker';
import IconButton from 'components/common/IconButton';
import PageHeader from 'components/common/PageHeader';
import FalconComponentCard from 'components/common/FalconComponentCard';
import audiences from '../../config/audiences';
import FileUpload from 'components/doc-components/FileUpload';

const CreateLatestNewsForm = () => {
  const navigate = useNavigate();
  const [fileUrlThumb, setFileUrlThumb] = useState(null);
  const [fileUrlImage, setFileUrlImage] = useState(null);

  const [formData, setFormData] = useState({
    title: '',
    brief: '',
    content: '',
    credit: 'ECPL',
    keyword1: '',
    keyword2: '',
    keyword3: '',
    post_date: moment.utc(new Date(), 'YYYY-MM-DD HH:mm').toDate(),
    date_added: moment.utc(new Date(), 'YYYY-MM-DD HH:mm').toDate(),
    date_updated: moment.utc(new Date(), 'YYYY-MM-DD HH:mm').toDate(),
    featured: false,
    enabled: true,
    user_id: null,
    audience: 'public',
  });

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        const uid = user.uid;
        setFormData({
          ...formData,
          user_id: uid,
        });
      } else {
        navigate('/login');
      }
    });

    return () => unsubscribe();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log('Form data', formData);
    console.log('Form fileUrlThumb', fileUrlThumb);
    console.log('Form fileUrlImage', fileUrlImage);

    const keywordsCombined = KeywordsMaker([
      formData.keyword1,
      formData.keyword2,
      formData.keyword3,
    ]);

    console.log('keywordsCombined', keywordsCombined);

    try {
      let formData2 = new FormData();
      formData2.append('title', formData.title);
      formData2.append('brief', formData.brief);
      formData2.append('content', formData.content);
      formData2.append('credit', formData.credit);
      formData2.append('keywords', keywordsCombined);
      formData2.append(
        'post_date',
        formData.post_date &&
          moment.utc(formData.post_date).format('YYYY-MM-DD HH:mm')
      );
      formData2.append(
        'date_added',
        formData.date_added &&
          moment.utc(formData.date_added).format('YYYY-MM-DD HH:mm')
      );
      formData2.append(
        'date_updated',
        formData.date_updated &&
          moment.utc(formData.date_updated).format('YYYY-MM-DD HH:mm')
      );
      formData2.append('featured', formData.featured);
      formData2.append('enabled', formData.enabled);
      formData2.append('fileUrlThumb', fileUrlThumb);
      formData2.append('fileUrlImage', fileUrlImage);
      formData2.append('user_id', formData.user_id);
      formData2.append('audience', formData.audience);

      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/news/create`,
        formData2
      );

      if (response) {
        toast.success(`News article uploaded successfully`, {
          theme: 'colored',
        });
      }
    } catch (err) {
      console.log('Error', err.message);
    }
  };

  const handleFieldChange = (e) => {
    const { name, value } = e.target;

    setFormData({
      ...formData,
      [name]: value,
    });
  };

  return (
    <>
      <PageHeader
        title='Create a news article'
        description='This new article will be listed on the news page and latest news section on the home page'
        className='mb-3'
      ></PageHeader>

      <FalconComponentCard>
        <FalconComponentCard.Header
          title='Details'
          light={false}
          noPreview={true}
        ></FalconComponentCard.Header>
        <Form onSubmit={handleSubmit}>
          <FalconComponentCard.Body>
            <Form.Label>Title</Form.Label>
            <Form.Control
              size='lg'
              type='text'
              placeholder=''
              name='title'
              onChange={handleFieldChange}
            />
            <br />
            <Form.Label>Author</Form.Label>
            <Form.Control
              size='lg'
              type='text'
              placeholder=''
              name='credit'
              onChange={handleFieldChange}
              readOnly
              defaultValue={formData.credit}
            />
            <br />
            <Form.Label>Brief</Form.Label>
            <Form.Control
              as='textarea'
              rows={2}
              name='brief'
              onChange={handleFieldChange}
            />
            <br />
            <Form.Label>Content</Form.Label>
            <Form.Control
              as='textarea'
              rows={4}
              name='content'
              onChange={handleFieldChange}
            />
            <br />

            <Row>
              <Col lg='6'>
                <Form.Group controlId='formFileLg' className='mb-3'>
                  <Form.Label>
                    Select Thumbnail photo (400px x 400px)
                  </Form.Label>
                  <FileUpload category={'news'} setFileUrl={setFileUrlThumb} />
                </Form.Group>
              </Col>

              <Col lg='6'>
                <Form.Group controlId='formFileLg' className='mb-3'>
                  <Form.Label>Select Article Inside photo</Form.Label>
                  <FileUpload category={'news'} setFileUrl={setFileUrlImage} />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col lang='6'>
                <Form.Group
                  controlId='formFileLg'
                  className='mb-3'
                  width='100%'
                >
                  <Form.Label>Post date</Form.Label>
                  <br />
                  <DatePicker
                    selected={formData.post_date}
                    onChange={(value) =>
                      setFormData({
                        ...formData,
                        post_date: value,
                      })
                    }
                    className='form-control'
                    placeholderText='DD-MM-YYYY H:mm'
                    timeIntervals={60}
                    dateFormat='dd-MM-yyyy H:mm'
                    showTimeSelect
                    fixedHeight
                    width='100%'
                    size='lg'
                    name='post_date'
                    autoComplete='off'
                    required
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col lg='6'>
                <Form.Group>
                  <Form.Label>Audience</Form.Label>
                  <Form.Select
                    size='md'
                    className='mb-3'
                    name='audience'
                    onChange={handleFieldChange}
                    defaultChecked={formData.audience}
                  >
                    {audiences.map((audience) => (
                      <option key={audience.value} value={audience.value}>
                        {audience.name}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col lg='6'>
                <Form.Group>
                  <Form.Check
                    name='featured'
                    type='checkbox'
                    id='featuredCheckbox'
                    label='Featured'
                    onChange={(e) =>
                      setFormData({ ...formData, featured: e.target.checked })
                    }
                    checked={formData.featured}
                  />
                </Form.Group>

                <Form.Group>
                  <Form.Check
                    name='enabled'
                    type='checkbox'
                    id='featuredCheckbox'
                    label='Enabled'
                    onChange={(e) =>
                      setFormData({ ...formData, enabled: e.target.checked })
                    }
                    checked={formData.enabled}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col lg='4'>
                <Form.Label>Keyword 1</Form.Label>
                <Form.Control
                  size='lg'
                  type='text'
                  placeholder=''
                  name='keyword1'
                  onChange={handleFieldChange}
                  defaultValue={formData.keyword1}
                />
              </Col>
              <Col lg='4'>
                <Form.Label>Keyword 2</Form.Label>
                <Form.Control
                  size='lg'
                  type='text'
                  placeholder=''
                  name='keyword2'
                  onChange={handleFieldChange}
                  defaultValue={formData.keyword2}
                />
              </Col>
              <Col lg='4'>
                <Form.Label>Keyword 3</Form.Label>
                <Form.Control
                  size='lg'
                  type='text'
                  placeholder=''
                  name='keyword3'
                  onChange={handleFieldChange}
                  defaultValue={formData.keyword3}
                />
              </Col>
            </Row>

            <Row>
              <Col lg='6' className='mt-4 mb-3 ml-3'>
                <Form.Group>
                  <IconButton
                    className='mb-1'
                    variant='falcon-default'
                    size='lg'
                    icon='plus'
                    transform='shrink-3'
                    type='submit'
                  >
                    Submit
                  </IconButton>
                </Form.Group>
              </Col>
            </Row>
          </FalconComponentCard.Body>
        </Form>
      </FalconComponentCard>
    </>
  );
};

export default CreateLatestNewsForm;
